/**
 * @file plusMinusToggle.component.tsx
 * @path apps/website/src/components/common/plusMinusToggle.component.tsx
 * @description
 */

import { motion } from "framer-motion";

interface PlusMinusToggleProps {
  isOpen: boolean;
}

/**
 * A toggle component that animates between a plus and minus sign.
 *
 * @param {PlusMinusToggleProps} props - The props for the component.
 * @returns {JSX.Element} The rendered toggle component.
 */
export const PlusMinusToggle = ({ isOpen }: PlusMinusToggleProps) => {
  const verticalVariants = {
    closed: { rotate: 0, scaleY: 1, opacity: 1 },
    open: { rotate: 90, scaleY: 0, opacity: 0 },
  };

  const horizontalVariants = {
    closed: { rotate: 0 },
    open: { rotate: 0 },
  };

  return (
    <motion.svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className="text-primary"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Horizontal line (always visible) */}
      <motion.line
        x1="5"
        y1="12"
        x2="19"
        y2="12"
        variants={horizontalVariants}
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        transition={{ duration: 0.25 }}
      />

      {/* Vertical line (morphs) */}
      <motion.line
        x1="12"
        y1="5"
        x2="12"
        y2="19"
        variants={verticalVariants}
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        transition={{ duration: 0.25 }}
      />
    </motion.svg>
  );
};
